import React, { useState } from 'react';
import Layout from '../components/layout/Layout';
import PhilosopherChat from '../components/study/PhilosopherChat';
import KnowledgeExplorer from '../components/study/KnowledgeExplorer';
import TimelineViewer from '../components/study/TimelineViewer';

const StudyPage = () => {
  const [activeTab, setActiveTab] = useState('philosophers');

  const tabs = [
    { key: 'philosophers', label: 'Philosopher Chat' },
    { key: 'knowledge', label: 'Knowledge Explorer' },
    { key: 'timeline', label: 'Timeline' },
  ];

  return (
    <Layout>
      <div className="max-w-6xl mx-auto px-4 py-8">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-3xl font-serif font-bold text-white">
            The Study
          </h1>
          <div className="flex space-x-1">
            {tabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                className={`px-4 py-2 text-sm font-medium rounded-md transition-colors ${
                  activeTab === tab.key
                    ? 'bg-oliveGold text-white'
                    : 'text-white/60 hover:text-white hover:bg-white/5'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        <div className="rounded-lg shadow-md border border-white/10 min-h-[600px] overflow-hidden" style={{ background: '#0f1d32' }}>
          {activeTab === 'philosophers' ? (
            <PhilosopherChat />
          ) : activeTab === 'knowledge' ? (
            <KnowledgeExplorer />
          ) : (
            <TimelineViewer />
          )}
        </div>
      </div>
    </Layout>
  );
};

export default StudyPage;
